import axios from 'axios'

const instance = axios.create({
	baseURL: 'https://kangoru-inventario-api.asiamart.com.mx',
})

/**
 * Interceptor para los requests, añadiendo el token de autorización
 */
instance.interceptors.request.use(
  (config) => {
    // Agregar el token de autorización en cada solicitud
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers['X-Frontend-Domain'] = window.location.host.replace('www.','');
    return config;
  },
  (error) => Promise.reject(error)  // Manejo de errores
);

/**
 * Interceptor para los responses, manejando el error 401
 */
instance.interceptors.response.use(
    function (response) { 
        return response; 
    }, 
    function (error) { 
        if (401 === error.response.status) { 
            window.location.replace('login');
        }

	return Promise.reject(error);
    }
);

export { instance as axios };
